import * as React from "react";

interface MoneyProps {
    amount: number;
    className?: string;
}

const Money = (props: MoneyProps) => {
    const classes: string[] = [];
    if (props.className) classes.push(props.className);
    const currencyFormatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
    });
    return (
        <span className={classes.join(" ")}>
            {currencyFormatter.format(+props.amount.toFixed(2))}
        </span>
    );
};

export default Money;
